export interface Review {
  id: string;
  rating: number;
  title: string;
  author: string;
  date: string;
  content: string;
}

export const reviews: Review[] = [
  {
    id: "unfrisky-1",
    rating: 5,
    title: "Underrated Gem",
    author: "unfrisky",
    date: "2025-02-22",
    content: "Found this game from a TikTok ad and it's so fun. I love the fact that you can own, renovate, and sell the houses. This game is like if goguessrr and the sims had a child."
  },
  {
    id: "hghsgcndnc-1",
    rating: 5,
    title: "Only App I Have Reviewed",
    author: "Hghsgcndnc",
    date: "2025-02-06",
    content: "This app is truly a 10/10. I have seen some bugs but the dev is SUPER responsive and active and will fix any issues others have said, beyond that this app is very fun and has an awesome future ahead of it. I love the ability to play and buy the houses near my area. Finally I have showed this app to plenty of people age 16-50 and they have all enjoyed playing and downloaded it because of me."
  },
  {
    id: "seper1-1",
    rating: 5,
    title: "Hearts",
    author: "Seper1",
    date: "2025-02-06",
    content: "fun game but should add feature to get hearts easier, maybe pay 1 time fee for unlimited or pay ingame money for hearts."
  },
  {
    id: "mayaa31-1",
    rating: 5,
    title: "great game",
    author: "mayaa31",
    date: "2025-02-03",
    content: "the game is really fun and the creators are super helpful and quick with support if you are having any issues!! i definitely recommend"
  },
  {
    id: "charlottealain-1",
    rating: 5,
    title: "Love it but want more",
    author: "Charlottealain",
    date: "2025-01-30",
    content: "I really love this game, I just finish all of the map in Calgary but I don't have anything to do anymore 😢"
  },
  // Original reviews
  {
    id: "renee-1",
    rating: 5,
    title: "Great game!",
    author: "Renee.W99",
    date: "2025-01-26",
    content: "I downloaded this game about a week ago and I can't get enough! It's the first game I can really get into in a long time! Also the customer service is amazing, fast responses & very nice!"
  },
  {
    id: "rji-1",
    rating: 5,
    title: "Fun!",
    author: "r.ji",
    date: "2025-01-11",
    content: "It's really fun and I like how it has real live updates. I think it would be cool to add player profiles that you can see with the houses they've bought, or being able to add your favorite houses to your profile, etc (for a more customized social experience in the game). I haven't all stars yet on my city so I'm not sure if you can see all to cities/houses all over the world after, but I think that might also be a fun feature!"
  },
  {
    id: "shani-1",
    rating: 5,
    title: "Update request",
    author: "Shani5623",
    date: "2025-01-10",
    content: "Amazing game. When will you be putting in renovations to make our properties more money?"
  },
  {
    id: "awilso-1",
    rating: 5,
    title: "Awesome game!",
    author: "awilso",
    date: "2024-12-06",
    content: "I really love the fact that you can choose your own city! When on tour I sometimes get houses that are a few blocks from my house and it's so fun! Really hope to see this game grow and will keep playing throughout its expansion!"
  },
  {
    id: "hootenpool-1",
    rating: 5,
    title: "Really fun",
    author: "Hootenpool",
    date: "2024-12-03",
    content: "This is the first game I have enjoyed on my phone in a long time. Simple, yet interesting and keeps you wanting to play. I look forward to the renovating feature. I would love to see more of the Okanagan BC, in the game down the road. Lots of interesting real estate here."
  },
  {
    id: "skate72-1",
    rating: 5,
    title: "Really fun game!",
    author: "Skate72",
    date: "2024-12-11",
    content: "I would've been scrolling through Zillow anyways but this makes it fun. I just wish there was a way to look at apartments and switch between different cities to explore what the housing stock is like over there."
  },
  {
    id: "john1841-1",
    rating: 5,
    title: "Best game fr",
    author: "John1841",
    date: "2024-11-27",
    content: "I like how it uses real house and stuff , it's a great game if your bored or even if you want to work as a home seller in Canada ! (GTA )"
  },
  {
    id: "twinsun69-1",
    rating: 5,
    title: "Great very well developed app",
    author: "Twinsun69",
    date: "2024-12-07",
    content: "This game is amazing from the concept to the in-game features like the scroll wheel guessing and the listings/offers, my only issue is there are a few bugs for example if you earn the nightmare stars for a neighborhood and you four house of it, please fix that thanks"
  },
  {
    id: "arravinth-1",
    rating: 5,
    title: "Really fun game",
    author: "Arravinth",
    date: "2025-04-19",
    content: "It's interesting to view the real estate market in each area. You can upgrade the houses and sell for profit! Collect all the properties and increase your net worth! Fun game! Hoping to see more cities added in the future 👌"
  },
  {
    id: "king13-1",
    rating: 4,
    title: "please add more cities",
    author: "king13🙂",
    date: "2025-04-17",
    content: "i love this game so much and i would love if you guys could add Ottawa to the game!"
  },
  {
    id: "mattwiebes-1",
    rating: 5,
    title: "Love it! But needs some work",
    author: "MattWiebes",
    date: "2025-04-10",
    content: "This game is so fun! I love looking at houses so this is the perfect game for me. I've been playing the game for a couple weeks now and have noticed a few things that need fixing. - sometimes when I open the game it doesn't load properly and I can't click anything. - sometimes when I try to collect from only 1 house, it doesn't collect the rent so I have to close the app and try again. - sometimes when I click buy, it says that the houses haven't loaded yet and to check back later Other than that I think the game is great and I can't wait to see what future updates will bring."
  },
  {
    id: "winkcj-1",
    rating: 4,
    title: "Love this game!",
    author: "Winkcj",
    date: "2025-04-02",
    content: "I've recently been playing this game and I really love it! I do wish that we could do a couple of things: - counter offer when we get offers on houses that were trying to sell - it would be nice if we could actually put offers in (I don't know how other offers are coming in from other players because I can never place an offer. I just have to pay whatever the ticket price) - Have more previews of what the AI enhancement will look like for the style I choose. Otherwise it's a really fun game and I love that it's real neighbourhoods in my city. Overall a really fun game!"
  },
  {
    id: "a2farshi12-1",
    rating: 5,
    title: "Very surprised!",
    author: "A2farshi12",
    date: "2025-03-30",
    content: "Yes, a game about real estate sounds like a boring premise. I got this game to try and guess house prices for fun and I was pleasantly surprised with this game. With the idea of real estate, this game absolutely maximized what it could have done. Brilliant job by the developers!"
  },
  {
    id: "evolve3750-1",
    rating: 5,
    title: "Learn about real estate pricing",
    author: "Evolve3750",
    date: "2025-03-30",
    content: "Amazing game excited for teams option Bobbyjane on top Things to add maybe - rewards for tour streaks -other ways to get money (non tour or rent) To developers Keep doing what your doing game is fun to play and educational. Yall are killing it"
  },
  {
    id: "oliviammt-1",
    rating: 5,
    title: "Love it!!",
    author: "oliviammt",
    date: "2025-03-22",
    content: "This game is so much fun I love looking through houses and the incentive to buy and sell to expand makes it really entertaining!! Only thing I would love to see is if you could watch ads to get more hearts cause waiting is brutal!! Love that you guys don't have ads though throughout the game irritating players!"
  }
]; 